import { render } from "./IconCatalog.vue?vue&type=template&id=2a777f28"
import script from "./IconCatalog.vue?vue&type=script&lang=js"
export * from "./IconCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__